module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/企业社会责任.d4370d47.png";